import {
    AbcOutlined,
    BadgeOutlined,
    CheckCircleRounded,
    CloseOutlined,
    DoNotDisturbOnRounded,
    DriveFileRenameOutlineOutlined,
    FilePresentOutlined,
    KeyOutlined,
    PinOutlined,
    RemoveCircleOutlineOutlined,
    SaveOutlined,
    SearchOutlined,
} from "@mui/icons-material";

import {
    Autocomplete,
    Box,
    Button,
    Chip,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    Pagination,
    Paper,
    Skeleton,
    styled,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";

import {
    SyntheticEvent,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import { useRecoilValue } from "recoil";
import { DeviceRequestType, DeviceType, SelectedParametersType, UserType } from "../../../types/types";
import { userAtom } from "../../../atoms/atoms";
import { ContentProps, Toast } from "primereact/toast";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";

import {
    getFilteredList,
    setToastRefToOpen,
} from "../../../functions/functions";

import GridTemplate from "../../../components/GridTemplate";
import Rmodal from "../../../components/Rmodal";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view";

import findAllDeviceManufacturersListResponse from "../../../resources/Api/device/findAllDeviceManufaturersListResponse";
import devicefindAllCrudResponse from "../../../resources/Api/device/deviceFindAllCrudResponse";
import deviceOnSaveData from "../../../resources/Api/device/deviceOnSaveData";
import deviceOnUpdateData from "../../../resources/Api/device/deviceOnUpdateData";
import deviceUpdateStatusById from "../../../resources/Api/device/deviceUpdateStatusById";
import deviceFindAllExportResponse from "../../../resources/Api/device/deviceFindAllExportResponse";
import * as xlsx from "xlsx";
import usePagination from "../../../utils/usePagination";
import deviceOnSaveListData from "../../../resources/Api/device/DeviceOnSaveListData";
import devicefindAllListResponse from "../../../resources/Api/device/devicefindAllListResponse";

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={<KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <DoNotDisturbOnRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    /* {
         field: "name",
         align: "left",
         width: 250,
         editable: false,
         sortable: false,
         renderHeader: () => (
             <Chip
                 sx={{
                     color: "#fff",
                     background: "transparent",
                     fontFamily: "Prometo",
                 }}
                 label={"Nome"}
                 icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
             />
         ),
         renderCell: (item) => (
             <Chip
                 sx={{
                     background: "transparent",
                     fontFamily: "Prometo",
                 }}
                 label={item.row.name}
             />
         ),
     },*/
    {
        field: "deviceManufacturerName",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Fabricante"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.deviceManufacturerName}
            />
        ),
    },
    {
        field: "model",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Modelo"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.model ? item.row?.model : "-"}
            />
        ),
    },
    {
        field: "imei",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"IMEI"}
                icon={<PinOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.imei}
            />
        ),
    },
    {
        field: "vehicleDepartmentCustomerReducedName",
        align: "left",
        width: 250,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Cliente"}
                icon={<PinOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.vehicleDepartmentCustomerReducedName ?? "Estoque"}
            />
        ),
    },
    {
        field: "vehicleDepartmentReducedName",
        align: "left",
        width: 250,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Departamento"}
                icon={<PinOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.vehicleDepartmentReducedName ?? "-"}
            />
        ),
    },
    {
        field: "vehiclePlate",
        align: "left",
        width: 150,
        headerClassName: "last-column",
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Placa em uso"}
                icon={<PinOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.vehiclePlate ?? "-"}
            />
        ),
    },
];

const rowsOptions = (list: Array<DeviceType>): Array<DeviceType> => {
    const result = [...list];
    return result.map((item) => ({ ...item }));
};

/**
 * DevicePage - Component that renders a page to list, create and manage tracker devices
 * @component
 */
const DevicePage = ({ isHiddenMenu }: { isHiddenMenu: boolean }) => {
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    // functionalities states
    const [isOnline, setIsOnline] = useState(true);
    const [loading, setLoading] = useState(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<"warn" | "success" | "info" | "error" | undefined>("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [inEdit, setInEdit] = useState<boolean>(false);
    const [inInsert, setInInsert] = useState<boolean>(false);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<DeviceType>>([]);
    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    const [query2, setQuery2] = useState<string>("");
    const [page, setPage] = useState(1);

    const [devicesList, setDevicesList] = useState<Array<DeviceType>>([]);
    const [deviceManufacturersList, setDeviceManufacturersList] = useState<
        Array<{ id: number; name: string }>
    >([]);

    const [selectedDevice, setSelectedDevice] = useState<DeviceType>({
        id: -1,
        name: "",
        serialNumber: "",
        imei: "",
        iccid: "",
        carrier: "",
        model: "",
        phoneNumber: "",
        deviceManufacturerId: -1,
        deviceManufacturerName: "",
        vehicleDepartmentCustomerReducedName: "",
        vehicleDepartmentReducedName: "",
        vehiclePlate: "",
        activated: true,
        lastUpdate: "",
        status: "",
        createdAt: ""
    });

    const [name, setName] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [imei, setImei] = useState("");
    const [iccid, setIccid] = useState("");
    const [carrier, setCarrier] = useState("");
    const [model, setModel] = useState("");
    const [deviceManufacturerName, setDeviceManufacturerName] = useState<string>("");

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    const [deviceImportedList, setDeviceImportedList] = useState<Array<DeviceRequestType>>([]);
    const [filteredImportedList, setFilteredImportedList] = useState<Array<DeviceRequestType>>([]);
    const [xlsxFile, setXlsxFile] = useState<string | null | undefined | File | any>(null);

    // refs
    const toastModalRef = useRef<Toast>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const autocompleteRef = useRef<any>(null);
    const toastRef = useRef<Toast>(null);

    // cookies
    const [cookies, _] = useCookies(["selectedParameters", "token"]);

    // hooks e const
    const location = useLocation();

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setTextValidation("");
        setIsOpenDetails(false);
        setName("");
        setSerialNumber("");
        setImei("");
        setCarrier("");
        setModel("");
        setIccid("");
        setInEdit(false);
        setInInsert(false);
        setDeviceManufacturerName("");
        setDeviceImportedList([]);
        setFilteredImportedList([]);
        setQuery("");
        setQuery2("");
    }, []);

    useEffect(() => {
        const ref = isOpenDetails ? toastModalRef : toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);


    const valueList = useMemo(() => filteredImportedList.length > 0 ? filteredImportedList : deviceImportedList, [filteredImportedList, deviceImportedList]);
    const count = Math.ceil(valueList.length / 40);
    const dataPage = usePagination<DeviceRequestType>({
        data: valueList,
        itemsPerPage: 40,
    });

    const handleChangePage = (event: any, page: any) => {
        setPage(page);
        dataPage.jump(page);
    };

    const getDeviceManufacturersList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        setLoading(true);
        try {
            const { data } = await findAllDeviceManufacturersListResponse(token);
            setDeviceManufacturersList(data);
        } catch (error: any) {
            console.log(error);
            setDeviceManufacturersList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.token]);

    useEffect(() => {
        getDeviceManufacturersList();
    }, [getDeviceManufacturersList]);

    const getAllDevicesList = useCallback(
        async (search: string = "", status: string = "activated", page: number = 0, size: number = 100) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const currentParameters: SelectedParametersType = cookies.selectedParameters;

            setLoading(true);
            try {
                const { data } = await devicefindAllCrudResponse(token, currentParameters.customer.id, status, page, size, search);
                setDevicesList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements)
                setPageNumber(data.pageable.pageNumber)

                if (data.first) {
                    setNumberOfElements(data.totalElements);
                }
            } catch (error: any) {
                console.log(error);
                setDevicesList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [cookies.token, location?.state?.customerId, location?.state?.secretaryId, cookies.selectedParameters]
    );

    useEffect(() => {
        getAllDevicesList();
    }, [getAllDevicesList]);

    const onSave = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        setLoading(true);

        const manufacturerId = deviceManufacturersList.find((item) => {
            if (item.name === deviceManufacturerName) return item;
        })?.id;

        const data: DeviceRequestType = {
            id: -1,
            name: name,
            imei: imei,
            iccid: iccid,
            carrier: carrier,
            model: model,
            serialNumber: serialNumber,
            deviceManufacturerId: manufacturerId!!,
            managerId: currentParameters.customer.id
        };

        if (
            (!data.name ||
                !data.imei ||
                !data.deviceManufacturerId) && deviceImportedList.length === 0
        ) {
            setTextValidation(
                "Os campos nome, IMEI e fabricante são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            if (deviceImportedList.length > 0) {
                await deviceOnSaveListData(token, deviceImportedList);
            } else {
                await deviceOnSaveData(token, data);
            }
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllDevicesList("", "activated", 0, 100);
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        deviceImportedList,
        getAllDevicesList,
        handleClose,
        cookies.token,
        name,
        serialNumber,
        iccid,
        imei,
        carrier,
        model,
        deviceManufacturerName,
        deviceManufacturersList,
        cookies.selectedParameters,
        isToastVisible
    ]);

    const onUpdate = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        setLoading(true);

        const manufacturerId = deviceManufacturersList.find((item) => {
            if (item.name === deviceManufacturerName) return item;
        })?.id;

        const data: DeviceRequestType = {
            id: selectedDevice.id,
            name: name,
            imei: imei,
            iccid: iccid,
            carrier: carrier,
            model: model,
            serialNumber: serialNumber,
            deviceManufacturerId: manufacturerId!!,
            managerId: currentParameters.customer.id
        };

        if (
            !data.name ||
            !data.imei ||
            !data.deviceManufacturerId
        ) {
            setTextValidation(
                "Os campos nome, IMEI e fabricante são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        if (
            data.name === selectedDevice.name &&
            data.serialNumber === selectedDevice.serialNumber &&
            data.imei === selectedDevice.imei &&
            data.iccid === selectedDevice.iccid &&
            data.carrier === selectedDevice.carrier &&
            data.deviceManufacturerId === selectedDevice.deviceManufacturerId &&
            data.model === selectedDevice.model
        ) {
            setTextValidation("Nada foi alterado.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await deviceOnUpdateData(token, data, data.id);
            setTextValidation("Registro atualizado com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllDevicesList("", "activated", 0, 100);
            }, 3000);

        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        cookies.token,
        name,
        serialNumber,
        iccid,
        imei,
        carrier,
        model,
        deviceManufacturerName,
        deviceManufacturersList,
        cookies.selectedParameters,
        getAllDevicesList,
        handleClose,
        selectedDevice
    ]);

    const verifyBeforeCancel = useCallback(
        (selected: DeviceType) => {
            const ref = toastModalRef;
            let canCancel = true;

            if (inEdit && !inInsert) {
                if (
                    name !== selected.name ||
                    serialNumber !== selected.serialNumber ||
                    imei !== selected.imei ||
                    iccid !== selected.iccid ||
                    carrier !== selected.carrier ||
                    deviceManufacturerName !== selected.deviceManufacturerName
                ) {
                    canCancel = false;
                }
            } else if (
                !inEdit &&
                inInsert &&
                (name ||
                    serialNumber ||
                    imei ||
                    iccid ||
                    carrier ||
                    deviceManufacturerName)
            ) {
                canCancel = false;
            }

            if (!canCancel) {
                if (!isToastVisible) {
                    setToastRefToOpen(
                        ref,
                        "Existem dados não salvos, deseja realmente cancelar?",
                        "Atenção!",
                        statusMessage,
                        {
                            content: (props: ContentProps) => (
                                <Box
                                    className="flex flex-column align-items-left"
                                    style={{ flex: "1" }}
                                >
                                    <Typography>{props?.message.summary}</Typography>
                                    <Box className="font-medium text-lg my-3 text-900">
                                        {props?.message.detail}
                                    </Box>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            handleClose();
                                        }}
                                    >
                                        Sim
                                    </Button>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            setIsToastVisible(false);
                                        }}
                                    >
                                        Não
                                    </Button>
                                </Box>
                            ),
                        },
                        undefined,
                        true
                    );
                    setIsToastVisible(true);
                }
            } else {
                handleClose();
            }
        },
        [
            inEdit,
            inInsert,
            handleClose,
            statusMessage,
            isToastVisible,
            name,
            serialNumber,
            iccid,
            imei,
            carrier,
            model,
            deviceManufacturerName,
        ]
    );

    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [lastRemoteQuery, setLastRemoteQuery] = useState("");

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(query);
        }, 1000); // tempo para considerar que PAROU de digitar

        return () => clearTimeout(handler);
    }, [query]);

    const getBySearch = useCallback(() => {
        const localResult = getFilteredList(
            ["name", "deviceManufacturerName", "imei", "vehicleDepartmentCustomerReducedName"],
            devicesList,
            debouncedQuery
        );

        if (localResult.length > 0) {
            setFilteredList(localResult);
        } else {
            setFilteredList([]);
        }

        // → evita loop: só chama API se query mudou
        if (debouncedQuery !== lastRemoteQuery && localResult.length <= 0) {
            setLastRemoteQuery(debouncedQuery);
            getAllDevicesList(debouncedQuery);
        }
    }, [
        debouncedQuery,
        getAllDevicesList,
        devicesList,
        lastRemoteQuery
    ]);

    useEffect(() => {
        getBySearch();
    }, [getBySearch]);

    const onUpdateStatus = useCallback(
        async (id: number, status: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            setLoading(true);
            try {
                await deviceUpdateStatusById(token, id, status);
                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
            } catch (error: any) {
                const { data } = error.response

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    getAllDevicesList("", "activated", 0, 100);
                }, 8000);
            }
        },
        [cookies.token, cookies.selectedParameters, getAllDevicesList, handleClose]
    );

    const verifyBeforeUpdateStatus = useCallback(
        (id: number, status: string) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente atualizar o status desse registro?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onUpdateStatus(id, status);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onUpdateStatus, isToastVisible, statusMessage]
    );

    const handleOnEditValues = useCallback(
        async (selectedDevice: DeviceType) => {
            if (selectedDevice?.name && !inInsert) {
                setName(selectedDevice.name);
                setSerialNumber(selectedDevice.serialNumber);
                setImei(selectedDevice.imei);
                setCarrier(selectedDevice.carrier);
                setModel(selectedDevice.model ?? "");
                setIccid(selectedDevice.iccid);
                setDeviceManufacturerName(selectedDevice.deviceManufacturerName);
            }
        },
        [inInsert]
    );

    const loadingEsqueleton = useMemo(() => {
        return (
            <Grid
                className="container "
                sx={{
                    height: 650,
                    width: 950,
                }}
            >
                {Array.from(new Array(1)).map((_, i) => (
                    <Box key={i} sx={{ width: "100%", height: 650, padding: 5 }}>
                        <Skeleton height={56} />
                        <Skeleton height={56} />
                        <Skeleton height={56} />
                        <Skeleton variant="rectangular" width={"100%"} height={350} />
                    </Box>
                ))}
            </Grid>
        );
    }, []);

    const CustomTreeItem = styled(TreeItem)({
        [`& .${treeItemClasses.iconContainer}`]: {
            "& .close": {
                opacity: 0.3,
            },
        },
    });

    const getReport = useCallback(async (type: string) => {
        setLoading(true);
        let dataBuffer = new ArrayBuffer(0);
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        let reportType = type;
        let isSimpleType = false;
        if (type.includes("simple")) {
            reportType = reportType.split(" ")[0];
            isSimpleType = true;
        };
        // simpleXlsxExport = false

        try {
            const { data } = await deviceFindAllExportResponse(cookies.token,
                currentParameters.customer.id,
                (devicesList.length > 0 && devicesList[0].activated)
                    ? "activated"
                    : "deactivated", reportType, isSimpleType)

            if ((data as ArrayBuffer).byteLength === 0) {
                setTextValidation("Nenhum dado para mostrar no relatório.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
            } else {
                setTextValidation("Relatório gerado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
                dataBuffer = data;
            }
        } catch (error: any) {
            const { data } = error.response

            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(data.reason);
        } finally {
            setTimeout(() => {
                handleClose();
                setReport(dataBuffer);
                setExportType(type);
            }, 3000);
        }
    }, [cookies.token, devicesList, handleClose, cookies.selectedParameters]);

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport = (exportType === "pdf" ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    useEffect(() => {
        setFilteredList(
            getFilteredList(
                ["name", "deviceManufacturerName", "imei", "vehicleDepartmentCustomerReducedName", "vehiclePlate"],
                devicesList,
                query
            )
        );
    }, [devicesList, query]);

    const readUploadFile = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;
        let deviceList = devicesList;
        // buscar lista simplificada no backend

        if (xlsxFile) {
            setLoading(true);

            if (numberOfElements > 100) {
                try {
                    const { data } = await devicefindAllListResponse(token, currentParameters.customer.id, "all");
                    deviceList = data;
                } catch (error) {
                    setTextValidation("Erro ao validar a lista importada, recarrege e tente novamente.");
                    setStatusMessage("warn");
                    setFieldsIsValid(false);
                }
            }

            const reader = new FileReader();
            reader.readAsArrayBuffer(xlsxFile);
            reader.onloadend = (event: ProgressEvent<FileReader>): void => {
                const data = event.target?.result as ArrayBuffer;
                const workbook = xlsx.read(data, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);

                const list: Array<DeviceRequestType> = [];
                if (json.length > 0) {
                    json.forEach((item: any) => {
                        const device: DeviceRequestType = {
                            id: -1,
                            imei: item?.DISPOSITIVO,
                            name: item?.DISPOSITIVO,
                            iccid: "",
                            carrier: "",
                            model: item?.MODELO,
                            serialNumber: "",
                            deviceManufacturerId: deviceManufacturersList.find((a) => a.name === item?.MARCA)?.id!!,
                            managerId: currentParameters.customer.id,
                        };

                        if (deviceList.some((a) => a.imei.toString().toLowerCase() === device.imei.toString().toLowerCase())) {
                            return;
                        } else {
                            if (list.every((a) => a.imei.toString().toLowerCase() !== device.imei.toString().toLowerCase())) {
                                list.push(device);
                            } else {
                                return;
                            }
                        }
                    });
                } else {
                    setLoading(false);
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation("O arquivo importado não é válido, verifique e tente novamente.");
                };
                setDeviceImportedList(list);
                setLoading(false);
            };
        };
    }, [xlsxFile, devicesList, cookies.selectedParameters, deviceManufacturersList, cookies.token, numberOfElements]);

    useEffect(() => {
        readUploadFile();
    }, [readUploadFile]);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails}
                hiddenBackdrop={false}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);

                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper
                    className="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    sx={style}
                >
                    <Box
                        className="row tw-m-0 tw-flex-1 tw-overflow-y-auto tw-bg-white tw-p-4 sm:tw-p-6"
                        sx={{
                            margin: 0,
                            width: "100%",
                            flex: 1,
                            overflowY: "auto",
                            backgroundColor: "#ffff",
                            boxShadow: "none",
                            padding: { xs: 2, sm: 3 },
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                            "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#ffff", transition: "box-shadow 200ms ease, background-color 200ms ease" },
                            "& .MuiOutlinedInput-root:hover": { backgroundColor: "rgba(0, 108, 119, 0.02)" },
                            "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "0 0 0 3px rgba(0, 108, 119, 0.10)" },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#006C77" },
                        }}
                    >
                        {!loading ? (
                            <>
                                <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                                    <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                        Identificação
                                    </Typography>
                                </Box>

                                <Box
                                    className="col-sm-12 col-md-5"
                                    style={{ display: "flex", justifyContent: "end" }}
                                >
                                    {selectedDevice?.name && (
                                        <>
                                            <Chip
                                                style={{
                                                    color: selectedDevice.activated
                                                        ? "#00B700"
                                                        : "#dc3545",
                                                    marginRight: 5,
                                                    width: "50%",
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={selectedDevice.activated ? "Ativo" : "Inativo"}
                                            />

                                            <Chip
                                                className="crud-metadata-chip"
                                                style={{
                                                    color: "black",
                                                    marginRight: 5,
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={selectedDevice.createdAt}
                                            />
                                            {selectedDevice.activated && (
                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 5,
                                                        width: "50%",
                                                    }}
                                                    disabled={!location?.state?.canEdit}
                                                    onClick={() => {
                                                        setInEdit(true);
                                                    }}
                                                    label="Editar"
                                                    icon={
                                                        <DriveFileRenameOutlineOutlined
                                                            style={{ height: 24, width: 24, fill: "black" }}
                                                        />
                                                    }
                                                />
                                            )}
                                            <Chip
                                                style={{
                                                    color: "black",
                                                    marginRight: 5,
                                                    width: "50%",
                                                }}
                                                disabled={!location?.state?.canEdit}
                                                onClick={() => {
                                                    if (!isToastVisible) {
                                                        verifyBeforeUpdateStatus(
                                                            selectedDevice.id,
                                                            selectedDevice.activated
                                                                ? "deactivate"
                                                                : "activate"
                                                        );
                                                    }
                                                }}
                                                label={
                                                    selectedDevice.activated ? "Desativar" : "Ativar"
                                                }
                                                icon={
                                                    <RemoveCircleOutlineOutlined
                                                        style={{ height: 24, width: 24, fill: "black" }}
                                                    />
                                                }
                                            />
                                        </>
                                    )}

                                    {inInsert && <>
                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            ref={fileInputRef}
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                const target = event.target;
                                                const file = target?.files;

                                                if (file && file[0]) {
                                                    setXlsxFile(file[0]);
                                                } else {
                                                    setXlsxFile(null);
                                                }
                                            }}
                                        />
                                        <Chip
                                            style={{
                                                color: "black",
                                                marginRight: 5,
                                                width: "50%",
                                            }}
                                            disabled={!location?.state?.canEdit}
                                            onClick={(e: any) => {
                                                e.preventDefault();
                                                if (fileInputRef.current) {
                                                    fileInputRef.current.click();
                                                }
                                            }}
                                            label="Importar"
                                            icon={
                                                <FilePresentOutlined
                                                    style={{ height: 24, width: 24, fill: "black" }}
                                                />
                                            }
                                        /></>}
                                </Box>
                                {deviceImportedList.length === 0 && <>
                                    <Box
                                        className="col-md-12"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-password-label"
                                                shrink
                                                required
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Nome
                                            </InputLabel>
                                            <TextField
                                                name="name"
                                                required
                                                autoComplete="off"
                                                InputProps={{
                                                    label: "Nome",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={name}
                                                onChange={(event) => {
                                                    setName(event.target.value);
                                                }}
                                                type="text"
                                                className="form-control form-control-login"
                                                placeholder="Digite o nome"
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <BadgeOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-password-label"
                                                shrink
                                                required
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Imei
                                            </InputLabel>
                                            <TextField
                                                name="imei"
                                                required
                                                autoComplete="off"
                                                InputProps={{
                                                    label: "Imei",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={imei}
                                                onChange={(event) => {
                                                    setImei(event.target.value);
                                                }}
                                                type="text"
                                                className="form-control form-control-login"
                                                placeholder="Digite o IMEI"
                                                inputProps={{ maxLength: 15 }}
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <PinOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-password-label"
                                                shrink
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Número serial
                                            </InputLabel>
                                            <TextField
                                                name="serialNumber"
                                                autoComplete="off"
                                                InputProps={{
                                                    label: "Número serial",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={serialNumber}
                                                onChange={(event) => {
                                                    setSerialNumber(event.target.value);
                                                }}
                                                type="text"
                                                className="form-control form-control-login"
                                                placeholder="Digite o serial (opcional)"
                                                inputProps={{ maxLength: 15 }}
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <PinOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-password-label"
                                                shrink
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Iccid
                                            </InputLabel>
                                            <TextField
                                                name="iccid"
                                                autoComplete="off"
                                                InputProps={{
                                                    label: "Iccid",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={iccid}
                                                onChange={(event) => {
                                                    setIccid(event.target.value);
                                                }}
                                                type="text"
                                                className="form-control form-control-login"
                                                placeholder="Digite o ICCID (opcional)"
                                                inputProps={{ maxLength: 22 }}
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <PinOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-password-label"
                                                shrink
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Operadora
                                            </InputLabel>
                                            <TextField
                                                name="carrier"
                                                autoComplete="off"
                                                InputProps={{
                                                    label: "Operadora",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={carrier}
                                                onChange={(event) => {
                                                    setCarrier(event.target.value);
                                                }}
                                                type="carrier"
                                                className="form-control form-control-login"
                                                placeholder="Digite a operadora (opcional)"
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <AbcOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 20px 0px" }}
                                    >
                                        <Autocomplete
                                            id="chip-label-select-country"
                                            className="input-select-country"
                                            style={{
                                                width: "100%",
                                                minHeight: "56px",
                                                height: "56px",
                                                backgroundColor: "#ffffff29",
                                                borderColor: "lightgray",
                                            }}
                                            options={deviceManufacturersList}
                                            value={deviceManufacturersList.find((a) => a.name === deviceManufacturerName) ?? null}
                                            onChange={(_, option) => {
                                                setDeviceManufacturerName(option?.name ?? "");
                                            }}
                                            getOptionLabel={(option) => `${option.name}`}
                                            noOptionsText={"Nada encontrado"}
                                            renderInput={(params) => (
                                                <>
                                                    <FormControl
                                                        className="form-group"
                                                        style={{ display: "flex" }}
                                                    >
                                                        <InputLabel
                                                            id="country-label"
                                                            required
                                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                            shrink
                                                            disabled={
                                                                (selectedDevice?.name &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean
                                                            }
                                                        >
                                                            Fabricante
                                                        </InputLabel>
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Selecione um fabricante"
                                                            autoComplete="off"
                                                            required
                                                            InputLabelProps={{ shrink: true }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                notched: true,
                                                                label: "Fabricante",
                                                                classes: {
                                                                    notchedOutline: "custom-notch",
                                                                },
                                                            }}
                                                        />
                                                    </FormControl>
                                                </>
                                            )}
                                            disabled={
                                                (selectedDevice?.name &&
                                                    !inEdit &&
                                                    !inInsert) as boolean
                                            }
                                        />
                                    </Box>

                                    <Box
                                        className="col-md-6"
                                        style={{ margin: "15px 0px 15px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex", width: "100%" }}
                                        >
                                            <InputLabel
                                                id="demo-multiple-password-label"
                                                shrink
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                style={{ fontFamily: "Prometo" }}
                                            >
                                                Modelo
                                            </InputLabel>
                                            <TextField
                                                name="carrier"
                                                autoComplete="off"
                                                InputProps={{
                                                    label: "Modelo",
                                                    notched: true,
                                                    style: { fontFamily: "Prometo" },
                                                }}
                                                disabled={
                                                    (selectedDevice?.name &&
                                                        !inEdit &&
                                                        !inInsert) as boolean
                                                }
                                                value={model}
                                                onChange={(event) => {
                                                    setModel(event.target.value);
                                                }}
                                                type="model"
                                                className="form-control form-control-login"
                                                placeholder="Digite o modelo (opcional)"
                                            />
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <AbcOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box></>}

                                {deviceImportedList.length > 0 && <>
                                    <Box
                                        className="col-md-12"
                                        style={{ margin: "15px 0px 20px 0px" }}
                                    >
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex" }}
                                        >
                                            <TextField
                                                id="chip-label-select-group"
                                                className="form-control input-select-group"
                                                autoComplete="off"
                                                ref={(ref) => autocompleteRef.current = ref}
                                                type="text"
                                                placeholder="Pesquise por IMEI"
                                                style={{
                                                    width: "100%",
                                                    minHeight: "56px",
                                                    height: "56px",
                                                    backgroundColor: "#ffffff29",
                                                    borderColor: "lightgray",
                                                }}
                                                label="Imei"
                                                value={query2}
                                                onChange={(event) => setQuery2(event.target.value)}
                                                onKeyDown={(event) => {
                                                    return (event.key === "Enter" ? setFilteredImportedList(
                                                        getFilteredList(
                                                            ["imei", "name"],
                                                            deviceImportedList,
                                                            query2
                                                        )
                                                    ) : null)
                                                }}
                                            />
                                            <IconButton
                                                className="visibility-password"
                                                disabled
                                                onMouseDown={(e: SyntheticEvent) => { }}
                                                edge="end"
                                                size="large"
                                            >
                                                <SearchOutlined />
                                            </IconButton>
                                        </FormControl>
                                    </Box>
                                    <Box
                                        style={{
                                            display: "grid",
                                            padding: "20px",
                                            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                                            gap: "10px",
                                        }}
                                    >
                                        {!loading && dataPage.currentData().map((it, idx) => {
                                            return (
                                                <Box key={idx}>
                                                    <Tooltip
                                                        title={
                                                            <Box>
                                                                <Typography>Imei: {it.imei}</Typography>
                                                                <Typography>Nome: {it.imei}</Typography>
                                                                <Typography>Marca: {deviceManufacturersList.find((a) => a.id === it.deviceManufacturerId)?.name ?? ""}</Typography>
                                                                <Typography>Modelo: {it.model}</Typography>
                                                            </Box>
                                                        }
                                                        style={{ color: "black", margin: 5, cursor: "pointer" }}
                                                    >
                                                        <Chip
                                                            key={Number(it?.imei) * idx}
                                                            label={it.imei}
                                                            onDelete={() => {
                                                                const newList = deviceImportedList.filter(
                                                                    (item) => item.imei !== it.imei
                                                                );
                                                                setFilteredImportedList([]);
                                                                setQuery2("");
                                                                setDeviceImportedList(newList);
                                                            }}
                                                            style={{ margin: 1, cursor: "pointer" }}
                                                        />
                                                    </Tooltip>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                    <Pagination
                                        style={{
                                            color: "#ffff",
                                            fontFamily: "Prometo",
                                            display: "flex",
                                            justifyContent: "end",
                                        }}
                                        count={count}
                                        size="large"
                                        page={page}
                                        shape="circular"
                                        onChange={handleChangePage}
                                        showFirstButton
                                        showLastButton
                                    />
                                </>}
                            </>
                        ) : (
                            loadingEsqueleton
                        )}
                    </Box>
                    <Box
                        className="tw-flex tw-w-full tw-flex-none tw-justify-end tw-border-t tw-border-black/10 tw-bg-white tw-p-4"
                        sx={{ display: "flex", width: "100%", alignSelf: "stretch", justifyContent: "flex-end", padding: 2, borderTop: "1px solid rgba(0, 0, 0, 0.10)", backgroundColor: "#ffff" }}
                    >
                        <Paper
                            className="tw-flex tw-w-full tw-flex-col-reverse tw-gap-2 sm:tw-w-auto sm:tw-flex-row"
                            elevation={0}
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column-reverse", sm: "row" },
                                justifyContent: "flex-end",
                                width: { xs: "100%", sm: "auto" },
                                marginLeft: "auto",
                                alignSelf: "flex-end",
                                gap: 1,
                                background: "transparent",
                            }}
                        >
                            <Button
                                type="button"
                                style={{
                                    fontFamily: "Prometo",
                                    color: "#ffff",
                                    marginRight: 5,
                                }}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        verifyBeforeCancel(selectedDevice);
                                    }
                                }}
                                className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <CloseOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Fechar
                                </Typography>
                            </Button>
                            <Button
                                type="button"
                                style={{ fontFamily: "Prometo", color: "#ffff" }}
                                disabled={!inEdit && !inInsert}
                                onClick={() => {
                                    inInsert && !inEdit ? onSave() : onUpdate();
                                }}
                                className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <SaveOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Salvar
                                </Typography>
                            </Button>
                        </Paper>
                    </Box>
                </Paper>
            </Rmodal>
        );
    }, [
        count,
        dataPage,
        deviceImportedList,
        handleChangePage,
        page,
        query2,
        selectedDevice,
        CustomTreeItem,
        location?.state?.canEdit,
        isToastVisible,
        validationText,
        isOpenDetails,
        loading,
        loadingEsqueleton,
        inInsert,
        inEdit,
        deviceManufacturerName,
        deviceManufacturersList,
        name,
        serialNumber,
        iccid,
        imei,
        carrier,
        model,
        deviceManufacturerName,
        deviceManufacturersList,
        onSave,
        onUpdate,
        verifyBeforeUpdateStatus,
        verifyBeforeCancel,
    ]);

    return (
        <>
            {DetailsModal}
            <Toast
                ref={toastRef}
                position="center"
                onShow={() => {
                    setIsToastVisible(true);

                    if (validationText) {
                        setTimeout(() => {
                            setIsToastVisible(false);
                            setTextValidation("");
                            setFieldsIsValid(true);
                        }, 3000);
                    }
                }}
            />
            <GridTemplate
                columns={columns}
                headerName="Dispositivos"
                isHiddenMenu={isHiddenMenu}
                isLoading={loading}
                order={"asc"}
                rows={rowsOptions(filteredList)}
                sortField="name"
                withFilter={true}
                withOptions={true}
                query={query}
                setQuery={(value: string) => setQuery(value)}
                filterPlaceholder={"Nome, fabricante, imei ou cliente"}
                onRefresh={getAllDevicesList}
                onExport={getReport}
                disableAddButton={!location?.state?.canCreate}
                handleNext={(activated: string, page: number, size: number) => getAllDevicesList("", activated, page, size)}
                handlePrevious={() => { }}
                isLastPage={isLastPage}
                totalPerPage={numberOfElementsPerPage}
                currentPage={pageNumber}
                totalElements={numberOfElements}
                onAdd={() => {
                    setIsOpenDetails(true);
                    setInInsert(true);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                onClickRow={(item: any) => {
                    setIsOpenDetails(true);
                    setSelectedDevice(item);
                    handleOnEditValues(item);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
            />
        </>
    );
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: { xs: "calc(100vw - 24px)", sm: "min(94vw, 1100px)" },
    maxWidth: 1100,
    maxHeight: "calc(100dvh - 24px)",
    overflow: "hidden",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: 0,
    fontFamily: "Prometo",
};

export default DevicePage;
